import { render, staticRenderFns } from "./companiesPriceListTable.vue?vue&type=template&id=d8e3ca62&"
import script from "./companiesPriceListTable.vue?vue&type=script&lang=ts&"
export * from "./companiesPriceListTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports